import React, { Component, Fragment } from "react";
import RcTooltip from "rc-tooltip";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

import { MAP_PROPERTY_EN_CN, PROPERTY_TEXT } from "@/utils/getting";
import { RoundNum } from "@/utils/setting";
import Store from "@/stores";

class PropertyTips extends Component {
	static propTypes = {
		name: PropTypes.string,
		val: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	}
	static defaultProps = {
		name: "",
		val: 0
	}
	render() {
		const { name, val } = this.props;
		return (
			<Fragment>{this.formatText(name, val)}</Fragment>
		);
	}
	formatText(name, val) {
		let val1 = 0;
		let val2 = 0;
		if (isNaN(val)) {
			const _val = val.split("|");
			val1 = _val[0];
			val2 = _val[1];
		} else {
			val1 = val;
		}
		return (PROPERTY_TEXT[name] || "")
			.replace(/x/g, `<span>${val1}</span>`)
			.replace(/y/g, `<span>${val2}</span>`)
			.replace(/a%/g, `<span>${val1}%</span>`)
			.replace(/b/g, `<span>${val1 / 10}</span>`)
			.split("\n").map(v => <p key={v} dangerouslySetInnerHTML={{ __html: v }} />);
	}
}

@observer
class Property extends Component {
	render() {
		const { class: classes, stats } = Store._ladderStore.hero;
		const { damage, dexterity, healing, intelligence, life, primaryResource, secondaryResource, strength, toughness, vitality } = stats;
		const bool = classes === "demon-hunter"
			? <Fragment>{primaryResource}<br />{secondaryResource}</Fragment>
			: <Fragment>{primaryResource}</Fragment>;
		const up = [
			{ name: "力量", val: Math.round(strength) },
			{ name: "敏捷", val: Math.round(dexterity) },
			{ name: "智力", val: Math.round(intelligence) },
			{ name: "体能", val: Math.round(vitality) }
		].map(v => (
			<RcTooltip
				key={v.name}
				destroyTooltipOnHide={true}
				overlay={<PropertyTips {...v} />}
				overlayClassName="ladder-property-tips"
				placement="rightBottom"
			>
				<li>{v.name}<span>{v.val}</span></li>
			</RcTooltip>
		));
		const down = [
			{ name: "伤害", val: Math.round(damage) },
			{ name: "坚韧", val: Math.round(toughness) },
			{ name: "恢复", val: Math.round(healing) }
		].map(v => (
			<RcTooltip
				key={v.name}
				destroyTooltipOnHide={true}
				overlay={<PropertyTips name={v.name} val={v.val} />}
				overlayClassName="ladder-property-tips"
				placement="rightBottom"
			>
				<li>{v.name}<span>{v.val}</span></li>
			</RcTooltip>
		));
		return (
			<div className="ladder-property fl">
				<h3>属性</h3>
				<ul className="normal">{up}</ul>
				<ul className="normal">{down}</ul>
				<ul className="special clearfix">
					<li>
						<RcTooltip
							destroyTooltipOnHide={true}
							overlay={<PropertyTips name="生命值" val={life} />}
							overlayClassName="ladder-property-tips"
							placement="rightBottom"
						>
							<i className="property-bool life">{RoundNum(life / 1000, 0)}k</i>
						</RcTooltip>
						生命值
					</li>
					<li>
						<RcTooltip
							destroyTooltipOnHide={true}
							overlay={<PropertyTips name={MAP_PROPERTY_EN_CN[classes]} val={classes === "demon-hunter" ? `${primaryResource}|${secondaryResource}` : primaryResource} />}
							overlayClassName="ladder-property-tips"
							placement="rightBottom"
						>
							<i className={`property-bool ${classes}`}>{bool}</i>
						</RcTooltip>
						{MAP_PROPERTY_EN_CN[classes]}
					</li>
				</ul>
			</div>
		);
	}
}
export default Property;